import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  height: calc(100vh - 135px - 80px - 80px);
  width: 100%;
  overflow: hidden;
  background: ${(props: any) => props.theme.colors.white};
`

export const StyleColumn = styled.div<any>`
  padding: 20px;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  height: 100%;
  overflow: auto;
  row-gap: 20px;
`
